import React, { Component } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";

import "./ChimneyListPage.less";
import ChimneyListContainer from "./ChimneyListContainer";

class ChimneyListPage extends Component {
  render() {
    return (
      <div className="chimney-list-page-component">
        <Row>
          <Col xs={12}>
            <div className="page-header">
              <h2>The Most Active Members of Dream Chimney</h2>
            </div>
          </Col>

          <Col xs={12}>
            <Row>
              <ChimneyListContainer
                render={({ chimneys }) =>
                  chimneys.map((chimney) => (
                    <Col xs={6} sm={6} md={4} lg={3} className="profile-wrapper text-center">
                      <Link to={`profile/${chimney.chimdir}`}>
                        <Image className="avatar avatar-md" src={chimney.avatar} roundedCircle fluid thumbnail />
                      </Link>
                      <div>
                        <Link to={`profile/${chimney.chimdir}`}>{chimney.full_name} Chimney</Link>
                      </div>
                      <div>{chimney.total} tracks</div>
                      {chimney.status && <div style={{ backgroundColor: "#ebebeb", padding: 3 }}>Status: {chimney.status}</div>}
                    </Col>
                  ))
                }
              />
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ChimneyListPage;
